import { ReactNode } from 'react';

const Label = ({
  label,
  className,
  children,
}: {
  label: string;
  className: string;
  children: ReactNode;
}) => {
  return (
    <div className={`flex flex-col gap-y-2 ${className}`}>
      <div>{label}</div>
      <div>{children}</div>
    </div>
  );
};

export default Label;
